import './styleForm.scss';
import { useSelector } from 'react-redux';
import { selectProduct } from '../../../../../../../../store/selectors/products';

const appFsoBackendUrl = window.env.APP_BROKERFRONT_FSO_BACKEND_URI;

const Form = () => {
  const { data } = useSelector(selectProduct);
  const { styles: Style } = data;
  const logoData = Style && Style.length > 0 ? Style.filter((item) => item.type === 'form')[0] : null;
  const hasLogoId = logoData?.styles?.logoFileId;

  return (
    <div className='rectangleParent'>
      <div className='groupItem' />
      <div className='inputText14'>Do zapłaty w ciągu 30 dni</div>
      <div className='inputText15'>O ile chcesz odroczyć płatność?</div>
      <div className='inputText16'>799,00 zł</div>
      <div className='frameParent'>
        <div className='groupContainer'>
          <span className='frameChildSelected'>
            <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <g id='Group 5153'>
                <circle id='Ellipse 161' cx='8' cy='8' r='7.5' fill='#F6F7FA' stroke='var(--formprimaryColor)' />
                <circle id='Ellipse 162' cx='8' cy='8' r='4' fill='var(--formprimaryColor)' />
              </g>
            </svg>
          </span>
          <div className='text'>Odroczona płatność</div>
        </div>
        <div className='groupContainer'>
          <span className='frameChild' />
          <div className='text'>Wybierz raty</div>
        </div>
      </div>
      <div className='inputTextWrapper'>
        <div className='inputText19'>Potwierdź dane do umowy</div>
      </div>
      <div className='frameWrapper2'>
        <div className='groupParent'>
          <div className='inputTextParent'>
            <div className='inputText'>Firma</div>
            <div className='inputText1'>Nazwa firmy</div>
          </div>
          <div className='inputTextGroup'>
            <div className='inputText'>NIP</div>
            <div className='inputText1'>000 000 00 00</div>
          </div>
          <div className='inputTextContainer'>
            <div className='inputText'>Właściciel</div>
            <div className='inputText1'>Jan Kowalski</div>
          </div>
          <div className='groupDiv'>
            <div className='inputText'>PESEL</div>
            <div className='inputText1'>00000066666</div>
          </div>
          <div className='inputTextParent1'>
            <div className='inputText'>Seria i nr dowodu</div>
            <div className='inputText1'>XXX000000</div>
          </div>
          <div className='inputTextParent2'>
            <div className='inputText'>Telefon</div>
            <div className='inputText1'>+48 000 000 000</div>
          </div>
          <div className='inputTextParent3'>
            <div className='inputText'>Email</div>
            <div className='inputText1'>przyklad@company.pl</div>
          </div>
        </div>
      </div>
      <div className='textParent'>
        <div className='text'>Potwierdzam</div>
        <span className='vectorIcon' />
      </div>
      <div className='textWrapper'>
        <div className='text'>Edytuj</div>
      </div>
      <div className='component61'>
        <div className='text2'>30 dni</div>
        <span className='vectorIcon1' />
      </div>
      <div className='inputContent'>
        <p className='otrzymaszPrzypomnienieO'>Otrzymasz przypomnienie o terminie</p>
        <p className='otrzymaszPrzypomnienieO'>płatności za pomocą SMS oraz e-mail.</p>
      </div>
      <div className='component57Parent'>
        <span className='component57Icon' />
        <div className='inputTextParent4'>
          <div className='text'>Split payment</div>
          <span className='frameInner' />
        </div>
      </div>
      {!hasLogoId ? (
        <div className='rectangleGroup'>
          <div className='groupInner' />
          <div className='rectangleDiv' />
          <div className='groupChild1' />
          <div className='groupChild2' />
          <div className='groupChild3' />
          <div className='groupChild4' />
          <div className='groupChild5' />
        </div>
      ) : null}
      <div className='rectangleContainer'>
        {hasLogoId ? (
          <img
            src={`${appFsoBackendUrl}/api/frontend/automatic-integration/logo/${logoData?.styles?.logoFileId}`}
            style={{ maxWidth: '200px', maxHeight: '50px' }}
          />
        ) : (
          <>
            <div className='groupChild6' />
            <div className='groupChild7' />
            <div className='inputText22'>Twój logotyp</div>
          </>
        )}
      </div>
    </div>
  );
};

export default Form;
